export default __webpack_public_path__ + "static/163-554f2b6a92153cd51c32faa57bd3cc72.jpg";